import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import "./AgentDocuments.scss";
import InvoicesList from "./invoices-list";
import ReceiptsList from "./receipts-list";
import ExpensesList from "./expenses-list";
import { SalariesList } from "./salaries-list";
import AccountsSearchField from "../accounts-search-field";
import { useParams } from 'react-router-dom';
import GeneralDocumentsCard from '../../../general-documents/GeneralDocumentsCard';

const AgentDocuments = (props) => {
  const {
    invoices,
    receipts,
    expenses,
    salaries,
    generalDocs,
    clients,
    suppliers,
    invoiceChanges = {},
    setInvoiceChanges = () => { },
    expenseChanges = {},
    setExpenseChanges = () => { }
  } = props;

  const { t, i18n } = useTranslation();
  const { type } = useParams();

  const [filterValue, setFilterValue] = useState("");
  const [updateTable, setUpdateTable] = useState(true);

  const titleMap = {
    invoices: t('invoices'),
    receipts: t('receipts'),
    expenses: t('expenses'),
    salaries: t('salaries'),
    'general-documents': t('general-docs'),
  };

  const placeholderMap = {
    invoices: t('search-by-invoice-number'),
    receipts: t('search-by-receipt-number'),
    expenses: t('general-search'),
    salaries: t('general-search'),
    'general-documents': t('general-search'),
  };

  const countMap = {
    invoices: invoices?.length || 0,
    receipts: receipts?.length || 0,
    expenses: expenses?.length || 0,
    salaries: salaries?.length || 0,
    'general-documents': generalDocs?.length || 0,
  };

  const showSearchField = ['invoices', 'receipts', 'expenses'].includes(type);

  return (
    <div className="agent-documents-wrapper">
      <div className={`title-wrapper ${i18n.language === 'heb' ? 'lng-heb' : 'lng-en'}`}>
        <h2 className="title">
          {type === 'salaries'
            ? titleMap[type].split(' ').map((word, index, arr) => (
              <span
                key={index}
                className={index >= arr.length - 2 ? 'last-two-words-gray' : ''}
              >
                {word}{" "}
              </span>
            ))
            : titleMap[type]
          }
        </h2>

        {/* {type === 'salaries' && (
          <div className="coming-soon"
          >{t('soon')}</div>
        )} */}
        <span className="items-count">{countMap[type]}</span>
      </div>

      {type === 'salaries' && (
        <div className={`subtitle ${i18n.language === 'heb' ? 'lng-heb' : 'lng-en'}`}>
          {t('salaries-subtitle')}
        </div>
      )}


      {showSearchField && (
        <AccountsSearchField
          filterValue={filterValue}
          setFilterValue={(value) => {
            setUpdateTable(false);
            setTimeout(() => setUpdateTable(true));
            setFilterValue(value);
          }}
          showSearchMessage={false}
          placeholder={placeholderMap[type]}
        />
      )}


      <div className="agent-documents-content">
        {type === 'invoices' && updateTable && (
          <InvoicesList
            invoices={invoices}
            clients={clients}
            invoiceChanges={invoiceChanges}
            setInvoiceChanges={setInvoiceChanges}
            filterValue={filterValue}
          />
        )}

        {type === 'receipts' && updateTable && (
          <ReceiptsList
            receipts={receipts}
            invoices={invoices}
            clients={clients}
            filterValue={filterValue}
          />
        )}

        {type === 'expenses' && updateTable && (
          <ExpensesList
            expenses={expenses}
            suppliers={suppliers}
            expenseChanges={expenseChanges}
            setExpenseChanges={setExpenseChanges}
            filterValue={filterValue}
          />
        )}

        {type === 'salaries' && updateTable && (
          <SalariesList
            salaries={salaries}
            filterValue={filterValue}
          />
        )}

        {type === 'general-documents' && updateTable && (
          <GeneralDocumentsCard documents={generalDocs} />
        )}
      </div>
    </div>
  );
};

export default AgentDocuments;
